import { COMMON_ACTION_TYPES, STUDY_BROWSER_ACTIONS } from "../../_constants";

const INITIAL_STATE = {
    studyBrowserList: {
        isLoading: false,
        data: [],
    },
    studyBrowserDetail: {
        isLoading: false,
        data: [],
    },
    onAddStudyOperationComment: {
        isLoading: false,
    }
}

const studyBrowserReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                studyBrowserList: {
                    isLoading: true,
                    data: []
                }
            }

        case STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                studyBrowserList: {
                    isLoading: false,
                    data: action.data
                }
            }

        case STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                studyBrowserList: {
                    isLoading: false,
                    data: []
                }
            }
        case STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.CLEAR:
            return {
                ...state,
                studyBrowserList: {
                    isLoading: false,
                    data: []
                }
            }
        // UPDATE_STUDY_BROWSER_LIST
        case STUDY_BROWSER_ACTIONS.UPDATE_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.SUCCESS:
                return {
                    ...state,
                    studyBrowserList: {
                        isLoading: false,
                        data: action.data
                    }
                }
        //    STUDY BROWSER DETAIL
        case STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                studyBrowserDetail: {
                    isLoading: true,
                    data: []
                }
            }

        case STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                studyBrowserDetail: {
                    isLoading: false,
                    data: action.data
                }
            }

        case STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                studyBrowserDetail: {
                    isLoading: false,
                    data: []
                }
            }
        //   ADD_STUDY_OPERATION_COMMENTL
        case STUDY_BROWSER_ACTIONS.ADD_STUDY_OPERATION_COMMENT + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                onAddStudyOperationComment: {
                    isLoading: true
                }
            }

        case STUDY_BROWSER_ACTIONS.ADD_STUDY_OPERATION_COMMENT + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                onAddStudyOperationComment: {
                    isLoading: false
                }
            }

        case STUDY_BROWSER_ACTIONS.ADD_STUDY_OPERATION_COMMENT + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                onAddStudyOperationComment: {
                    isLoading: false
                }
            }

        default:
            return state;
    }
}

export default studyBrowserReducer
